export default __webpack_public_path__ + "static/media/perk-common.b562ecb6.png";